import { type FC } from 'react'
import { FormattedMessage } from 'react-intl'

import { NumberedListItem } from 'base-ui'

export const ProductPageOdsDialogVideoConsultationStepsSection: FC = () => (
  <ol className="mt-3.5">
    <NumberedListItem>
      <FormattedMessage id="pdp.buyboxwithvariants.odsModalVC.process.step1" />
    </NumberedListItem>
    <NumberedListItem>
      <FormattedMessage id="pdp.buyboxwithvariants.odsModalVC.process.step2" />
    </NumberedListItem>
    <NumberedListItem>
      <FormattedMessage id="pdp.buyboxwithvariants.odsModalVC.process.step3" />
    </NumberedListItem>
  </ol>
)
